import styled from 'styled-components'
import { MathFormulaDisplay } from '@edulastic/common'

export const StyledMathFormulaDisplay = styled(MathFormulaDisplay)`
  color: ${(props) => props.theme.widgets.matchList.dragItemColor};
`
